var render = function render(){var _vm=this,_c=_vm._self._c;return _c('summary-count',{attrs:{"title":"Active Prescriptions","is-loading":_vm.isLoading,"count":_vm.activePrescriptions,"change-count":_vm.changeCount},on:{"cardClicked":function($event){return _vm.gotoLink()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }